module.exports = __webpack_public_path__ + "img/in-small.93138384.svg";